<c-container class="mt-5">
  <h2>How To Play Editor</h2>

  <form [formGroup]="howToPlayForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-hint>How To Play Text</mat-hint>
      <textarea matInput formControlName="howToPlay" data-testid="how-to-play-input"></textarea>
    </mat-form-field>
    <p class="hint-text" data-testid="how-to-play-empty-hint">Players see this text on the game's How to Play page. Leave it empty to show them the standard How to Play page instead.</p>

    <div class="margin-top-large markdown-preview">
      <span>How To Play Preview</span>
      <markdown [data]="howToPlayControl.value ?? ''"></markdown>
    </div>
  </form>

  <button mat-flat-button color="primary"
          data-testid="how-to-play-submit-button"
          [disabled]="uiState === uiStateEnumForTemplate.ShowLoading"
          (click)="submit()">Submit
  </button>
</c-container>
